<template>
  <b-modal
    id="modal-indice"
    centered
    :title="`Add ${indice ? indice.name : ''}`"
    :no-close-on-backdrop="true"
  >
    <!--<v-select
      v-model="selected"
      v-validate="{ required: true }"
      :options="options"
      label="name"
      :placeholder="`Search ${indice ? indice.name : ''}`"
      data-vv-name="Indices"
      multiple
      @search="debounceSearch"
    ></v-select>-->
    <multiselect
              v-model="selected"
              v-validate="{ required: true }"
              label="name"
              track-by="label"
              placeholder="Search"
              :size="'compact'"
              :options="options"
              :multiple="true"
              :searchable="true"
              :internal-search="false"
              :clear-on-select="false"
              :close-on-select="false"
              :options-limit="300"
              :limit="10"
              @search-change="debounceSearch"
            >
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag multiselect__tag">
                  <span>{{ option.label }}</span>
                  <i class="multiselect__tag-icon" @click="remove(option)"></i>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <span>{{ props.option.label }}</span>
                <i v-if="props.option.searchRequired" class="fa fa-book-open ml-1"></i>
                <i v-if="props.option.searchable" class="fa fa-search ml-1"></i>
              </template>
              <span slot="noResult">
                Oops! No elements found. Consider changing the search query.
              </span>
    </multiselect>

    <template slot="modal-footer">
      <b-btn
        variant="primary"
        class="float-right"
        :disabled="!selected.length"
        @click="addIndice"
        ><i class="fa fa-plus" /> Add to query</b-btn
      >
    </template>
  </b-modal>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import { mapActions } from "vuex";

export default {
  name: "IndiceSearchModal",
  components: {
    vSelect,
    Multiselect
  },
  props: {
    indice: {
      type: Object,
      required: false, // TODO: Check if required
      default: null // TODO: Remove default value if required
    }
  },
  data() {
    return {
      search: null,
      options: [],
      selected: []
    };
  },
  watch: {
    indice() {
      this.options = [];
      this.selected = [];
    }
  },
  methods: {
    ...mapActions(["searchIndices"]),
    addIndice() {
      this.$emit("addToQuery", this.indice.type, this.selected);
      this.$bvModal.hide("modal-indice");
      this.options = [];
      this.selected = [];
    },
    debounceSearch: _.debounce(function(val) {
      if (!val) {
        return false;
      }

      this.searchIndices({
        query: val,
        index: this.indice.name
      }).then(res => {
        this.options = res.map(
          indice =>
            (indice = {
                ...indice,
                label: indice.name,
                value: indice.id
            })
        );
      });
    }, 400)
  }
};
</script>
